import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { AButton, AField, aInput } from "./ui";

const FIELDS = [
  { name: "contact_email", label: "Contact Email" },
  { name: "phone", label: "Phone" },
  { name: "address", label: "Headquarters Address", textarea: true },
  { name: "branches", label: "Upcoming Branches (one per line)", textarea: true, list: true },
  { name: "linkedin", label: "LinkedIn URL" },
  { name: "twitter", label: "Twitter / X URL" },
  { name: "github", label: "GitHub URL" },
  { name: "seo_title", label: "SEO Title" },
  { name: "seo_description", label: "SEO Description", textarea: true },
];

const SettingsTab = () => {
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/admin/settings").then((r) => setForm(r.data)).catch((e) => toast.error(formatApiError(e)));
  }, []);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.put("/admin/settings", form);
      toast.success("Settings saved.");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div data-testid="admin-tab-settings">
      <h2 className="font-display text-xl font-bold tracking-tight">Site Settings</h2>
      <p className="mt-1 text-sm text-tark-dim">Contact details, social links and SEO metadata shown across the site.</p>
      <form onSubmit={save} className="mt-6 max-w-3xl rounded-2xl border border-tark-line bg-tark-card p-6">
        <div className="grid gap-4 sm:grid-cols-2">
          {FIELDS.map((f) => (
            <div key={f.name} className={f.textarea ? "sm:col-span-2" : ""}>
              <AField label={f.label}>
                {f.textarea ? (
                  <textarea rows={3} className={aInput}
                            value={f.list ? (form[f.name] || []).join("\n") : (form[f.name] || "")}
                            onChange={(e) => setForm({
                              ...form,
                              [f.name]: f.list
                                ? e.target.value.split("\n").map((s) => s.trim()).filter(Boolean)
                                : e.target.value,
                            })}
                            data-testid={`settings-${f.name}`} />
                ) : (
                  <input className={aInput} value={form[f.name] || ""} onChange={(e) => setForm({ ...form, [f.name]: e.target.value })} data-testid={`settings-${f.name}`} />
                )}
              </AField>
            </div>
          ))}
        </div>
        <div className="mt-6">
          <AButton type="submit" disabled={saving} testId="settings-save-btn">{saving ? "Saving…" : "Save Settings"}</AButton>
        </div>
      </form>
    </div>
  );
};

export default SettingsTab;
